import React, {useState, useEffect, useContext} from 'react';
import { Collapse } from 'antd';
import {UserContext} from "../common/UserContext";
import axios from "../common/axios";
import UserReviewFeedback from "./UserReviewFeedback";
import {TemplateContext} from "../common/TemplateContext";
import CircularLoader from "../common/CircularLoader";

const { Panel } = Collapse;

const UserReview = props => {
    const [testResults, setTestResults] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {user, setUser} = useContext(UserContext);
    const {singlePage} = useContext(TemplateContext);

    useEffect(() => {
        if (user.userId !== undefined) {
            axios.get('/web/ui/test/userDiagnosticTestResults')
                .then(response => {
                    setTestResults(response.data);
                    setLoading(false);
                });
        }
    }, []);

    if(isLoading) {
        return (
            <CircularLoader pageCentered={false}/>
        )
    }

    return (
        <>
            <h2 id="drawer-title">Review</h2>
            {testResults.length > 0 &&
                <Collapse>
                    {testResults.map((testResult, index) => (
                        <Panel header={testResult.testName} key={testResult.testResultId}>
                            <UserReviewFeedback key={testResult.testResultId} testResultId={testResult.testResultId} title={testResult.testName} />
                        </Panel>
                    ))}
                </Collapse>
            }
            {testResults.length == 0 &&
                <div className={"ch-nav-drawer-blk disabled-message"}>No test results</div>
            }
        </>
    )
}

export default UserReview;